const AUTH_KEY = "zydex_auth";
const SESSION_USER = "zydex_user";
const TOKEN_KEY = "zydex_token";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function isAuthenticated() {
  return localStorage.getItem(AUTH_KEY) === "1" && !!localStorage.getItem(TOKEN_KEY);
}

export function getSessionUser() {
  return localStorage.getItem(SESSION_USER) || "";
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export async function login(username, password) {
  const user = (username || "").trim();
  const pass = password || "";

  try {
    const res = await fetch(`${BACKEND_URL}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: user, password: pass }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { ok: false, error: data.detail || "Invalid username or password." };
    }
    localStorage.setItem(AUTH_KEY, "1");
    localStorage.setItem(SESSION_USER, data.username || user);
    localStorage.setItem(TOKEN_KEY, data.token);
    return { ok: true };
  } catch {
    return { ok: false, error: "Cannot reach server. Try again." };
  }
}

export async function logout() {
  const token = getAuthToken();
  try {
    if (token) {
      await fetch(`${BACKEND_URL}/api/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  } catch {
    /* ignore */
  }
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(SESSION_USER);
  localStorage.removeItem(TOKEN_KEY);
}
